import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Class composer with Tailwind conflict resolution, so `className` overrides win. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
